import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class MessagesService {

  constructor(private _toastr: ToastrService) { }

  public ShowError(msg:string):void{
    this._toastr.error(msg);
  }
  public ShowSuccess(msg:string):void{
    this._toastr.success(msg);
  }

}
